import React from 'react';
import { EEmoji } from '@/shared/enums/emoji.enum';

interface ISentimentsItemProps {
  sentiment: string;
  value: number;
}

const SentimentsItem = ({ sentiment, value }: ISentimentsItemProps) => {
  if (!sentiment) {
    return null;
  }

  const type = sentiment.toUpperCase() as keyof typeof EEmoji;
  const emoji = EEmoji[type];

  return (
    <div className="elem-sentiment">
      <span className="emoji">{emoji}</span>
      <span className="value">{value}</span>
    </div>
  );
};

export default SentimentsItem;
